
import arrayMixin from './arrayMixin';

export default {
  name: 'XhMultipleSelect', // 新建 multiple select
  components: {},
  mixins: [arrayMixin],
  props: {},
  data: function data() {
    return {};
  },

  computed: {
    option: function option() {
      var array = [];
      if (this.item && this.item.data.setting) {
        for (var index = 0; index < this.item.data.setting.length; index++) {
          var element = this.item.data.setting[index];
          array.push({ value: element });
        }
      }
      return array;
    }
  },
  watch: {},
  mounted: function mounted() {},

  methods: {}
};